import { render } from "./NewsView.vue?vue&type=template&id=3507a8e4&scoped=true"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"

import "./NewsView.vue?vue&type=style&index=0&id=3507a8e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3507a8e4"]])

export default __exports__